import { createAction, props } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { ExtensionRegisterListItem } from '../models/extension-register-results.model';
import { ExtensionTypeOption } from '../models/extension-type-option.interface';
import { ExtensionsFilterOption } from '../models/extensions-filter-option';

const area = 'Extension Register';
export const extensionRegisterAdapterActions = createRegisterActions<ExtensionRegisterListItem>(area);

export const createExtension = createAction(
   `[${area}] Create Extension`,
   props<{ createExtensionTypeOption: ExtensionTypeOption }>()
);

export const extensionRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: ExtensionsFilterOption[] }>()
);

export const changeSipUserPasswords = createAction(
   `[${area}] Change Sip User Password`,
   props<{ sipUserIds: number[] }>()
);

export const changeSipUserPasswordSuccess = createAction(`[${area}] Change Sip User Password Success`);

export const changeSipUserPasswordFailure = createAction(
   `[${area}] Change Sip User Password Failure`,
   props<SingleGraphError>()
);

export const setOrderingOptionsFromSessionStorage = createAction(
   `[${area}] Set Ordering Options From Session Storage`,
   props<{ orderingOptions: OrderingOption[] | null }>()
);
